import type { Stone, OwnedStone } from '../domain/types';
import { maxStageForRarity } from '../domain/economy';
import { StoneIcon } from './StoneIcon';

interface StoneCardProps {
  stone: Stone;
  owned?: OwnedStone;
  onClick?: () => void;
}

export function StoneCard({ stone, owned, onClick }: StoneCardProps) {
  const stage = owned?.currentStage ?? 0;
  const max = maxStageForRarity(stone.rarity);
  const owned_ = owned !== undefined;

  return (
    <button
      className={`stone-card ${owned_ ? 'owned' : 'unowned'}`}
      onClick={onClick}
      type="button"
      aria-label={`${stone.name}${owned_ ? ` 段階${stage}` : ' 未所持'}`}
    >
      <div className="stone-card__icon">
        {owned_ ? (
          <StoneIcon stone={stone} stage={stage} size={84} />
        ) : (
          <div className="stone-card__silhouette" aria-hidden>
            <StoneIcon stone={stone} stage={0} size={84} />
          </div>
        )}
      </div>
      <div className="stone-card__name">{stone.name}</div>
      <div className="stone-card__meta">
        {owned_ ? (
          <span className="stone-card__stage">
            段階 {stage} / {max}
          </span>
        ) : (
          <span className="stone-card__rarity">未所持</span>
        )}
      </div>
    </button>
  );
}
